import cn from 'classnames/bind';
import * as React from 'react';

import {
  deleteAllNotifications,
  getHasNewNotifications,
  getNotifications,
  markAllNotificationAsRead,
  markNotificationAsRead,
} from '../../../../../../client/services/notificationCenter';

import { ELkType } from '../../../../../repositories/header/entities/response/HeaderV1Schema';

import { NotificationCenter } from '../../../../NotificationCenter';

import { NotificationsProps } from './types';

const styles = require('./Notifications.css');

export const Notifications: React.FC<NotificationsProps> = props => {
  const { lkType, count, link, notificationCenterData } = props;

  switch (lkType) {
    case ELkType.Specialist: {
      return (
        <span className="c-header__notifications-mobile-wrap">
          <a href={link} className="c-header__notifications-mobile">
            <span className={cn('c-header-active-notification', { [styles['display-none']]: !count })} />
          </a>
        </span>
      );
    }

    default: {
      return (
        <span className="c-header__notifications-mobile-wrap" id="header-user-notification-center--mobile">
          <NotificationCenter
            newHeaderEnabled
            notificationCenterData={notificationCenterData}
            getNotifications={getNotifications}
            getHasNewNotifications={getHasNewNotifications}
            markNotificationAsRead={markNotificationAsRead}
            markAllNotificationAsRead={markAllNotificationAsRead}
            deleteAllNotifications={deleteAllNotifications}
          />
        </span>
      );
    }
  }
};

Notifications.displayName = 'Notifications';
